<template>
  <div class="services">
    <services-card />
    <!-- <schedule-session-card /> -->
  </div>
</template>

<script>
import ServicesCard from '../cards/ServicesCard'
// import ScheduleSessionCard from '../cards/ScheduleSessionCard'

const setOpenGraphMeta = require('./_helpers/openGraph.js')

export default {
  name: 'services',
  components: {
    ServicesCard,
    // ScheduleSessionCard,
  },
  mounted () {
    setOpenGraphMeta({
      ogUrl: 'https://www.rewardingdogtraining.com/services',
      ogTitle: 'Services - Rewarding Dog Training',
      ogDescription: 'Private and virtual sessions to help with separation anxiety, basic manners, reactivity, calmness, and more. Packages include Separation anxiety and Basic Manners.',
    })
  },
}
</script>

<style lang="scss">
</style>
